// extracted by mini-css-extract-plugin
export default {"Container":"TagItem_Container__ores4","Title":"TagItem_Title__2xlWB","CloseIcon":"TagItem_CloseIcon__5rsVp"};